import { Box, Typography, SvgIcon } from '@mui/material'
import { 
    circleInfoIcon,
  } from '../../components/common/iconPaths'

import custom from '../../styles/mui/szVariables.json'

export default function AuthSuccess({ message }: any) {

    return (
        <Box
            id="successMessage"
            display={message?"flex":"none"}
            mt={custom.spacing.sm}
            mb={custom.spacing.xxs}
            p={custom.spacing.sm}
            sx={{
                borderRadius: custom.corners4,
                border: 2,
                borderColor: 'success.main',
                backgroundColor: 'rgba(0, 153, 64, 0.05)'
            }}>
            <SvgIcon color='success'
                sx={{ pr: custom.spacing.xxxs }}>
                {circleInfoIcon}
            </SvgIcon>
            <Typography  
                id="successTitle"
                textAlign="left" 
                variant="szHeading.Bold.xSmall"
                color="success">
                    {message?.title || message}
                    <Typography
                        id="successMessage"
                        color="text.primary"
                        textAlign={"left"}
                        pt={custom.spacing.xxxs} 
                        variant="szBody.Regular.Medium">
                        <br/>{message?.message || ''}
                    </Typography>
            </Typography>

        </Box>
    )
}